module.exports = __webpack_public_path__ + "static/media/YB5F03_0.21e8e711.jpg";